import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { nativePostMessage } from "../common/components/NativeInterface";
import { sessionActions } from "../store";

export default function AccessDeniedPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleGoBack = async () => {
        await fetch('/api/session', { method: 'DELETE' });
        nativePostMessage('logout');
        navigate('/login');
        dispatch(sessionActions.updateUser(null));
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "grey.100",
                px: 2,
            }}
        >
            <Card
                sx={{
                    maxWidth: 420,
                    width: "100%",
                    textAlign: "center",
                    p: 3,
                    borderRadius: 3,
                    boxShadow: 3,
                }}
            >
                <CardContent>
                    {/* Icon */}
                    <Avatar
                        sx={{
                            bgcolor: "error.light",
                            color: "error.main",
                            width: 56,
                            height: 56,
                            margin: "0 auto",
                            mb: 2,
                        }}
                    >
                        <LockOutlinedIcon />
                    </Avatar>

                    {/* Title */}
                    <Typography variant="h5" fontWeight={600} gutterBottom>
                        Acceso restringido
                    </Typography>

                    {/* Message */}
                    <Typography variant="body1" color="text.secondary" mb={3}>

                        No tienes acceso a esta plataforma.
                    </Typography>

                    {/* Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleGoBack}
                    >
                        Regresar
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
}